module.exports = __webpack_public_path__ + "img/i18n.be0e231.png";